import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { OFFER_SUMMARY_CARD_BASE_CLASSNAME } from './Constants';
import { createOfferSummaryCard } from './OfferSummaryCard';
createComponents(".".concat(OFFER_SUMMARY_CARD_BASE_CLASSNAME), createOfferSummaryCard, NO_PATTERN_BUSINESS_LOGIC);
